import React from "react";
import BaseModel from "../models/BaseModel";
import TemplateGroup from "../models/TemplateGroup";

import TemplateGroupDialog from "../modelDialogs/TemplateGroupDialog";
import TreeViewModel, { DragMode, DropResult } from "../models/TreeviewModel";

import Logger from "../Logger";
import DeviceTemplate from "../models/DeviceTemplate";
import { isUiModeDeveloper } from "../uiMode";
import { DeviceClasses } from "../models/DeviceClasses";
import { itx } from "../translationItx/itx";
import { ApplicationMode } from "../models/SettingsEnums";

const logger = new Logger();

export default class TemplateGroupTreeViewModel extends TreeViewModel {
  get typedObj(): TemplateGroup {
    return this.obj as TemplateGroup;
  }

  get isFolder(): boolean {
    return true;
  }

  getTagNeeded(): boolean {
    return false;
  }

  getDisableEdit(): boolean {
    return true;
  }

  get childCollection(): Array<BaseModel> | undefined {
    logger.log("get child collections for Templategroup " + this.typedObj.name);
    return [
      ...this.typedObj.templateGroups.sortBySensytive("tagOrName"),
      ...this.typedObj.templates.sortBySensytive("tagOrName"),
    ];
  }

  async handleDrop2(mode: DragMode, obj: BaseModel): Promise<DropResult> {
    return super.handleDrop2(DragMode.move, obj);
  }

  ////////////////////////////////////////////////////////////////////////////////////////
  //
  // inline menu buttons
  //
  //super.inlineButton_Properties(),
  ////////////////////////////////////////////////////////////////////////////////////////

  getButtons(): JSX.Element[] | undefined {
    let buttons = this.canAddTemplate ? [super.inlineButton_Add("ContextMenuLables.addTemplate")] : []; // no itx
    const thisGroupType = (this.typedObj as TemplateGroup).templateGroupType;
    const possibleGroupTypes = [
      DeviceClasses.Actor,
      DeviceClasses.Button,
      DeviceClasses.SensorNew,
      DeviceClasses.DecentralActor,
    ];
    if (possibleGroupTypes.includes(thisGroupType)) {
      buttons = [super.inlineButton_Open("homePane.openAssignTemplates"), ...buttons]; // no itx  will be translated later is the translation key
    }

    return buttons;
  }

  ////////////////////////////////////////////////////////////////////////////////////////
  //
  // context menu
  //
  ////////////////////////////////////////////////////////////////////////////////////////

  private get canAddTemplate(): boolean {
    return true;
  }

  async handleAdd() {
    if (!this.canAddTemplate) return;
    const { openTemplateGroupProductSelection } = await import("../components/ProductSelection/openTemplateGroupProductSelection");
    if (this.canAddTemplate) openTemplateGroupProductSelection(this.typedObj);
  }
  handleDelete(): void {
    //
    // Delete all Templates
    //
    this.typedObj.templates.deleteAllItems();
  }
  handleProperties() {
    state.dialogManager.openDialog(<TemplateGroupDialog obj={this.typedObj} />);
  }

  ////////////////////////////////////////////////////////////////////////////////////////
  canBePastedInteractive(copiedObjClassName: string): boolean {
    if (copiedObjClassName == "DeviceTemplate") {
      return true;
    }

    return false;
  }

  /////////////////////////////////////////////////////////////////////////////////777///
  async getDisabledContextMenuItems(): Promise<Array<string>> {
    const copiedObjClassName = state.clipboard.getClassName();
    if (copiedObjClassName && copiedObjClassName == "DeviceTemplate") {
      return new Array<string>();
    }

    return ["paste"]; // no itx
  }

  get contextMenuItems(): any {
    var subLabelPaste = undefined;

    try {
      subLabelPaste = state.contextMenuManager.clipboardData.items[0].name;
    } catch (ex) {
      logger.error(ex);
    }

    const buttons = [
      this.baseContextMenuItems_Paste(subLabelPaste),
      ...(this.canAddTemplate ? [super.baseContextMenuItems_Add("ContextMenuLables.addTemplate")] : []), // no itx
    ];

    return {
      title: this.obj?.name,
      items: buttons,
    };
  }

  replace1(s: string, sOld: string, sNew: string): string {
    const regexOpen = new RegExp(`<${sOld}(\\s|>)`, "g");
    const regexClose = new RegExp(`</${sOld}(\\s|>)`, "g");

    let res = s.replace(regexOpen, `<${sNew}$1`);
    res = res.replace(regexClose, `</${sNew}$1`);

    return res;
  }
}
